import React, { useEffect, useState } from 'react';
import {
  Alert, Form, Input, Button, Divider, Radio, Toast,
} from '@roo/roo';

import { phoneRuleWithoutRequired, getRuleLen, emailRule } from '@utils/rules';
import { getNominationDetail, postNomination } from '@assets/apis/base';
import UploadField from '@components/UploadPro';
import Header from '@components/HomeHeader/HomeHeader';
import { APPLY_PERIOD_CHINESE, APPLY_YEAR } from '@utils/config';
import './index.scss';

const { Field } = Form;
const { Group: RadioGroup } = Radio;
const { Textarea } = Input;

const noticeText = `温馨提示：
本年度青山科技奖提名工作将于${APPLY_YEAR}年7月25日24时截止，逾期将无法提名。请您关注提名期限。被提名人进入评审流程后，提名人将回避参与奖项相关的评审工作。如有任何问题，请联系010-56114793。`;

const reasonOptions = [{
  value: 'online',
  label: '在线填写',
}, {
  value: 'file',
  label: '上传提名信',
}];

const toastError = () => Toast.open({
  title: '错误提示',
  children: '提名理由为空',
  duration: 5000,
  theme: 'light',
  status: 'fail',
});

const toastSuccess = () => Toast.open({
  title: '成功提示',
  children: '发送成功',
  duration: 5000,
  theme: 'light',
  status: 'success',
});

const Nomination = (props) => {
  const code = props.match.params.nominationCode;
  const [detail, setDetail] = useState(null);
  const [hasCommited, setHasCommited] = useState(false);
  const [edit, setEdit] = useState(false);
  useEffect(() => {
    getNominationDetail({ code })
      .then((res) => {
        const { nominator, nominee, status } = res;
        if (status !== 'toNominate') setHasCommited(true);
        const newDetail = {
          nominatorName: nominator.name,
          nominatorPhoneNo: nominator.phone,
          nominatorOrgnanization: nominator.organization,
          nominatorPosition: nominator.position,
          nomineeName: nominee.name,
          nomineeOrgnanization: nominee.organization,
          nomineeEmail: nominee.email,
          nomineeRelation: nominee.relation,
          nominationText: nominee.nominationText,
          nominationUrl: nominee.nominationUrl,
          nominationType: nominee.nominationType,
        };
        setDetail(newDetail);
      });
  }, []);
  return (
    <div>
      <Header />
      <div className="nomination">
        <h2>
          第
          {APPLY_PERIOD_CHINESE}
          届青山科技奖提名
        </h2>
        <Divider />
        <div style={{ padding: '0 24px' }}>
          <Alert
            className="nomination-alert"
            type="warning"
            icon="roo-icon-exclamation-circle"
            title={noticeText}
          />
          {
            detail ? (
              <Form
                value={detail}
                cols={{ field: { span: 8, offset: 0 }, label: { span: 3 } }}
                onSubmit={(values, error) => {
                  if (Array.isArray(error) && error.length) return;
                  const {
                    nominatorName,
                    nominatorPhoneNo,
                    nominatorOrgnanization,
                    nominatorPosition,
                    nomineeName,
                    nomineeOrgnanization,
                    nomineeEmail,
                    nomineeRelation,
                    nominationText,
                    nominationUrl,
                    nominationType,
                  } = values;
                  if (!nominationType) {
                    toastError();
                    return;
                  }
                  if (nominationType === 'online' && !nominationText) {
                    toastError();
                    return;
                  }
                  if (nominationType === 'file' && !nominationUrl) {
                    toastError();
                    return;
                  }
                  const body = {
                    nominator: {
                      name: nominatorName,
                      phoneNo: nominatorPhoneNo,
                      organization: nominatorOrgnanization,
                      position: nominatorPosition,
                    },
                    nominee: {
                      name: nomineeName,
                      organization: nomineeOrgnanization,
                      email: nomineeEmail,
                      relation: nomineeRelation,
                      nominationText,
                      nominationUrl,
                      nominationType,
                    },
                  };
                  postNomination({ ...body, code })
                    .then((res) => {
                      toastSuccess();
                      setTimeout(() => location.reload(), 500);
                    });
                }}
              >
                {
                  ({ values, _, submitForm }) => (
                    <>
                      <h3>提名人信息</h3>
                      <Divider />
                      <div className="form-patch">
                        <Field
                          name="nominatorName"
                          label="提名人姓名"
                          required
                        >
                          {
                            ({ value, handleChange }) => (
                              <Input value={value} onChange={handleChange} disabled />
                            )
                          }
                        </Field>
                        <Field
                          name="nominatorPhoneNo"
                          label="&nbsp;&nbsp;&nbsp;手机号码"
                          rule={{ ...phoneRuleWithoutRequired }}
                        >
                          {
                            ({ value, handleChange }) => (
                              <Input value={value} onChange={handleChange} placeholder="请填写您的常用手机号码" disabled={hasCommited} />
                            )
                          }
                        </Field>
                        <Field
                          name="nominatorOrgnanization"
                          label="单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位"
                          required
                          rule={getRuleLen(200, true)}
                        >
                          {
                            ({ value, handleChange }) => (
                              <Input value={value} onChange={handleChange} placeholder="请填写您当前所在单位" disabled={hasCommited} />
                            )
                          }
                        </Field>
                        <Field
                          name="nominatorPosition"
                          label="职&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;务"
                          required
                          rule={getRuleLen(50, true)}
                        >
                          {
                            ({ value, handleChange }) => (
                              <Input value={value} onChange={handleChange} placeholder="请填写您当前职位" disabled={hasCommited} />
                            )
                          }
                        </Field>
                      </div>
                      <h3>被提名人信息</h3>
                      <Divider />
                      <div className="form-patch">
                        <Field
                          name="nomineeName"
                          label="姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名"
                          required
                          rule={getRuleLen(50, true)}
                        >
                          {
                            ({ value, handleChange }) => (
                              <Input value={value} onChange={handleChange} placeholder="请填写被提名人的真实姓名" disabled={hasCommited} />
                            )
                          }
                        </Field>
                        <Field
                          name="nomineeOrgnanization"
                          label="单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位"
                          required
                          rule={getRuleLen(200, true)}
                        >
                          {
                            ({ value, handleChange }) => (
                              <Input value={value} onChange={handleChange} placeholder="请填写被提名人的当前所属单位" disabled={hasCommited} />
                            )
                          }
                        </Field>
                        <Field
                          name="nomineeEmail"
                          label="邮&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;箱"
                          required
                          rule={{ ...emailRule }}
                        >
                          {
                            ({ value, handleChange }) => (
                              <Input value={value} onChange={handleChange} placeholder="请填写被提名人的常用邮箱，我们将给TA发送您的提名码" disabled={hasCommited} />
                            )
                          }
                        </Field>
                        <Field
                          name="nomineeRelation"
                          label="您与被提名者关系"
                          required
                          rule={getRuleLen(50, true)}
                        >
                          {
                            ({ value, handleChange }) => (
                              <Input value={value} onChange={handleChange} placeholder="请填写您与被提名人的关系" disabled={hasCommited} />
                            )
                          }
                        </Field>
                        <Field
                          layout="vertical"
                          name="nominationType"
                          label="提名理由"
                          required
                        >
                          {
                            ({ value, handleChange }) => (
                              <RadioGroup
                                disabled={hasCommited && !edit}
                                value={value}
                                onChange={(value) => {
                                  handleChange(value);
                                }}
                              >
                                {
                                  reasonOptions.map((item) => (
                                    <Radio value={item.value}>{item.label}</Radio>
                                  ))
                                }
                              </RadioGroup>
                            )
                          }
                        </Field>
                        {
                          values.nominationType !== 'file' ? (
                            <Field
                              layout="vertical"
                              name="nominationText"
                              required
                            >
                              {
                                ({ value, handleChange }) => (
                                  <Textarea
                                    disabled={hasCommited && !edit}
                                    value={value}
                                    onChange={handleChange}
                                    className="apply-area"
                                    maxLength={1000}
                                    placeholder="请填写被提名人最近五年的主要成果1-3项，以及您支持TA的理由。（限1000字）"
                                  />
                                )
                              }
                            </Field>
                          ) : (
                            <Field
                              layout="vertical"
                              name="nominationUrl"
                              required
                            >
                              {({ value, handleChange }) => (
                                <div>
                                  {/*<div className='t-info' >*/}
                                  {/*  <Icon name='info-circle-o' />*/}
                                  {/*  项目申报书内容需包含项目的技术可行性描述、项目有关地方政府资源及合作方、项目预算、项目目前投入资金、项目设社会影响力及环境效益等。*/}
                                  {/*</div>*/}
                                  <UploadField
                                    disabled={hasCommited && !edit}
                                    value={value}
                                    onChange={handleChange}
                                    maxFiles={1}
                                    type="all"
                                    canPreview
                                  />
                                </div>
                              )}
                            </Field>
                          )
                        }
                        {
                          !hasCommited ? (
                            <Field formType="submit">
                              <Button onClick={submitForm}>确认发送</Button>
                            </Field>
                          ) : (
                            <div>
                              {edit ? (
                                <Field formType="submit">
                                  <Button onClick={() => {
                                    setEdit(false);
                                    /** 重置form数据为初始数据 */
                                    setDetail({ ...detail, dateline: new Date().getTime() });
                                  }}
                                  >
                                    取消
                                  </Button>
                                  <Button onClick={submitForm}>确认修改</Button>
                                </Field>
                              ) : (
                                <Field formType="submit">
                                  <Button onClick={() => {
                                    setEdit(true);
                                  }}
                                  >
                                    修改
                                  </Button>
                                </Field>

                              )}
                            </div>

                          )
                        }
                      </div>
                    </>
                  )
                }
              </Form>
            ) : null
          }
        </div>
      </div>
    </div>
  );
};

export default Nomination;
